import './Modal.css'
export default function ConfirmModal({ isOpen, onConfirm, onCancel, message, header, tipo }) {
  if (!isOpen) return null;

  return (
    <div className="modal-backdrop h-100">
      <div className="modal-content h-100 d-flex justify-content-center align-items-center">
        <div className="modal-box d-flex flex-column justify-content-between ">
          <div className='header'>
            <h2 className='text-white ps-3 mt-2'>{header}</h2>
          </div>
          <div className='body text-center text-white'>
            <p>{message}</p>
          </div>
          {tipo === 'confirmacion' ? 
            <div className='buttons d-flex justify-content-center w-100 mb-2'>
              <button onClick={onConfirm} className="btn btn-danger me-5">Aceptar</button>
              <button onClick={onCancel} className="btn btn-outline-grey ms-5 text-white">Cancelar</button>
            </div>
          :
            <div className='buttons d-flex justify-content-center w-100 mb-2'>
              <button onClick={onConfirm} className="btn btn-outline-grey">Aceptar</button>
            </div>
          }
        </div>
      </div>
    </div>
  );
}
